<template>
<div>
    <div class="form-group">
        <label for="mobile">{{labels.enterMobile}}</label>
        <fa-icon :icon="['fas','info-circle']" tabindex="0" class="icon ml-1" :aria-label="'Mobile Phone number tooltip:' + stripHtml(labels.mobileAlerts)" aria-hidden="false" v-tooltip="labels.mobileAlerts" />
        <input type="tel" aria-required="true" id="mobile" v-bind:class="{'error': inMobileNumberError}" name="mobile" class="form-control" maxlength="14" v-model="maskedNumber" v-maska="maskValue" :placeholder="placeholder" @blur="onMobileNumberBlur">
        <p v-if="inMobileNumberError" class="mt-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.mobileNumberInvalid}}</p>
    </div>
    <div class="form-group" v-if="updateEmailPhoneTwice">
        <label for="confirmMobile">{{labels.confirmMobile}}</label>
        <input type="tel" aria-required="true" id="confirmMobile" v-bind:class="{'error': inConfirmMobileNumberError}" name="confirmMobile" class="form-control" maxlength="14" v-model="confirmMobileNumber" v-maska="maskValue" :placeholder="placeholder" @blur="onConfirmMobileNumberBlur">
        <p v-if="inConfirmMobileNumberError" class="mt-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.mobileNumberNotMatched}}</p>
    </div>
</div>
</template>

<script>
   import {stripHtml} from "../../../utility/miscellaneous";
    export default {
        name: "MultiFactorPhoneNumber",

        emits: ['set-phone-number'],

        props: {
            labels: Object
        },

        data: function() {
            return {
                maskedNumber: "",
                maskValue: "(###) ###-####",
                placeholder: "(999) 999-9999",
                updateEmailPhoneTwice: RESOURSE_PROPERTIES.updateEmailPhoneTwice,
                confirmMobileNumber: "",
                inMobileNumberError: null,
                inConfirmMobileNumberError: null
            }
        },

        methods: {
            stripHtml,
            demask: function(val) {
                var regex = new RegExp(/[0-9]/g);
                var arr = val.match(regex);
                var number = "";

                if (arr !== null) {
                    number = arr.join("");
                }
                
                return number;
            },
            isMobileNumberValid: function(){
                return this.demask(this.maskedNumber).length === 10 && this.maskedNumber !== ""
            },
            isConfirmMobileNumberValid: function() {
                return this.confirmMobileNumber === this.maskedNumber && this.confirmMobileNumber !== "";
            },
            onMobileNumberBlur: function() {
                this.setInMobileNumberError();
                if(this.updateEmailPhoneTwice && this.confirmMobileNumber != "")
                    this.setInConfirmMobileNumberError();
            },
            onConfirmMobileNumberBlur: function() {
                this.setInConfirmMobileNumberError();
            },
            setInMobileNumberError: function(){
                this.inMobileNumberError = !(this.isMobileNumberValid());
                return !this.inMobileNumberError;
            },
            setInConfirmMobileNumberError: function() {
                this.inConfirmMobileNumberError = !(this.isConfirmMobileNumberValid());
                return !this.inConfirmMobileNumberError;
            },
            validateAndEmitMobileNumber: function (val) {
                this.emitMobileNumber(this.isMobileNumberValid() && (this.updateEmailPhoneTwice ? this.isConfirmMobileNumberValid() : true) ? this.maskedNumber : "");
            },
             emitMobileNumber: function(val){
                this.$emit('set-phone-number', this.demask(val))
            }
        },

        watch: {
            maskedNumber: function() {
                 this.inMobileNumberError = false;
                if(this.updateEmailPhoneTwice)
                    this.inConfirmMobileNumberError = false;
                this.validateAndEmitMobileNumber();
            },
            confirmMobileNumber: function(){
                this.inConfirmMobileNumberError = false;
                this.validateAndEmitMobileNumber();
            }
        }
    }
</script>